<div [class.dark-theme]="isDarkMode()">
  <router-outlet />
</div>
<tour-step-template />
